import type { SVGProps } from 'react';

const SvgCampaigns = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="campaigns">
      <path d="M30.75.94A.75.75 0 0 0 30 .78L3 11.06a.76.76 0 0 0 0 1.42l12.42 4 4.24 12.34a.76.76 0 0 0 .7.51.76.76 0 0 0 .71-.5l9.86-27.09a.76.76 0 0 0-.18-.8ZM5.52 11.71l21.76-8.3-11.45 11.64Zm14.89 14.64L16.9 16.1 28.35 4.46Z" />
      <path d="m1.928 29.18 9.685-9.845 1.07 1.052-9.686 9.844zM9.553 28.95l4.446-4.52 1.07 1.052-4.447 4.52zM1.877 21.66l4.446-4.52 1.07 1.052-4.447 4.52z" />
    </g>
  </svg>
);

export default SvgCampaigns;
